import { Link } from 'react-router-dom';
import { comics, trendingComicIds } from '@/mocks/comics';

export default function RankingSection() {
  const ranked = trendingComicIds
    .map((id) => comics.find((c) => c.id === id))
    .filter(Boolean)
    .slice(0, 10)
    .sort((a, b) => (b?.rating || 0) - (a?.rating || 0));

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热门排行榜</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">根据阅读量和用户评分综合排名，发现大家都在追的韩漫</p>
        </div>

        <div className="flex flex-col gap-2">
          {ranked.map((comic, index) => comic && (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-4 p-3 md:p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full font-heading text-sm font-bold flex-shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </div>
              <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden bg-background-100">
                <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-label font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{comic.author} · {comic.category}</p>
              </div>
              <div className="hidden sm:flex items-center gap-3 text-xs text-foreground-500 flex-shrink-0">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500"></i> {comic.rating}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i> {comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
                </span>
              </div>
              <span className={`hidden sm:inline px-2 py-0.5 rounded-full text-[10px] font-label flex-shrink-0 ${
                comic.status === '连载中' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-6">
          <Link
            to="/category/fantasy-adventure"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-label transition-colors cursor-pointer"
          >
            查看完整排行榜 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}